import { openDB } from "idb";

const openProductDB = async () => {
  return openDB("ProductDB", 2, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("fullData")) {
        db.createObjectStore("fullData", { keyPath: "id" });
      }
    },
  });
};

const isEqual = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);

export const saveProductsToDB = async (products: any[]) => {
  try {
    const db = await openProductDB();
    const tx = db.transaction("fullData", "readwrite");
    const store = tx.objectStore("fullData");

    const updates = [];

    for (const product of products) {
      const existing = await store.get(product.id);
      if (!existing || !isEqual(existing, product)) {
        await store.put(product);
        updates.push(product.id);
      }
    }

    await tx.done;

    if (updates.length > 0) {
      console.log(`Updated/added ${updates.length} listings:`, updates);
    } else {
      console.log("No new or updated listings to save.");
    }
  } catch (error) {
    console.error("Error saving products to DB:", error);
  }
};

export const getProductsFromDB = async () => {
  try {
    const db = await openProductDB();
    const tx = db.transaction("fullData", "readonly");
    const store = tx.objectStore("fullData");

    const products = await store.getAll();
    await tx.done;
    return products;
  } catch (error) {
    console.error("Error fetching products from DB:", error);
    return [];
  }
};
